
import { IPlatFormResponse } from '../../types/system/platform';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 系统设置 - 平台设置 - 详情
 */
export async function getSystemPlatform() {
  let data = {} as IPlatFormResponse;

  try {
    const { code, context, message } = await Http.post<IPlatFormResponse>(`${hostUrl}/side/sys/setting/info`);

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || {} as IPlatFormResponse;

      data = items || {} as IPlatFormResponse;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 系统设置 - 平台设置 - 修改
 */
export async function editSystemPlatform(params: IPlatFormResponse) {
  params = JSON.parse(JSON.stringify(params)) as IPlatFormResponse;

  try {
    const { code, message } = await Http.post<any>(`${hostUrl}/side/sys/setting/update`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}
